export default __webpack_public_path__ + "static/media/22.afc113d1.jpg";